import firebase from "firebase/app";
import http from "../../service/data-service";

export default {
  state: {
    session: {
      token: localStorage.getItem("token") || "",
      user: {
        id: localStorage.getItem("id") || "",
        name: localStorage.getItem("name") || "",
        username: localStorage.getItem("username") || "",
        uid: localStorage.getItem("uid") || "",
        acesso: localStorage.getItem("acesso") || "",
      },
    },
  },
  getters: {
    session(state: any) {
      return state.session;
    },
    isLoggedIn(state: any) {
      return !!state.session.token;
    },
  },
  mutations: {
    setSession(state: any, session: any) {
      state.session = session;
    },
    clearSession(state: any) {
      state.session.token = "";
      state.session.user.id = "";
      state.session.user.name = "";
      state.session.username = "";
      state.session.uid = "";
      state.session.acesso = "";
    },
  },
  actions: {
    signUserIn({ commit }: { commit: any }, payload: any) {
      commit("setLoading", true);
      commit("clearError");
      return new Promise((resolve, reject) => {
        http
          .post("/api/v1/users/signInWeb/", payload)
          .then((result: any) => {
            if (result.data.type == "ok") {
              localStorage.setItem("token", result.data.value.token);
              localStorage.setItem("username", result.data.value.user.email);
              localStorage.setItem("name", result.data.value.user.nome);
              localStorage.setItem("id", result.data.value.user.id);
              localStorage.setItem("uid", result.data.value.user.uid);
              localStorage.setItem("acesso", result.data.value.user.acesso);
              commit("setSession", result.data.value);
            } else {
              commit("setError", result.data.msg);
            }
            commit("setLoading", false);
            resolve(result.data);
          })
          .catch((err: any) => {
            // localStorage.removeItem("token");
            // //commit("setError", err.response || err);
            // try {
            //   reject(err.response.data.error);
            // } catch (e) {
            //   reject(err);
            // }
          });
      }).catch((err) => {
        console.log(err);
        // commit("setLoading", false);
        // commit("setError", err.message);
      });
    },
    signUserOut({ commit }: { commit: any }) {
      firebase.auth().signOut();
      localStorage.clear();
      commit("setUser", null);
    },
    autoSignUserIn({ commit }: { commit: any }, payload: any) {
      console.log("autosign");
      firebase
        .auth()
        .currentUser?.getIdToken()
        .then((token: any) => {
          localStorage.setItem("token", token);

          commit("setUser", {
            id: payload.uid,
            uid: payload.uid,
            email: payload.email,
            name: payload.displayName,
          });
        });
    },
  },
};
